// extracted by mini-css-extract-plugin
module.exports = {"mytop":"header_mytop_NJ66I","userinfo":"header_userinfo_JBGkh"};